var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHowItWorksImg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 158.531,
    height: 169.123,
    viewBox: "0 0 158.531 169.123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2986",
    "data-name": "Rectangle 2986",
    width: 158.531,
    height: 169.123,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22464",
    "data-name": "Group 22464",
    transform: "translate(-296 -2839.929)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22238",
    "data-name": "Path 22238",
    d: "M78.979-18.826c25.094,6.608,39.343,16.193,51.148,21.953C151.385,13.5,156.947,18,156.947,18v85.572l-15.508,10.492-62.25,28.69L13.043,112.125,1.9,106.685,0,18Z",
    transform: "translate(296 2862.888)",
    fill: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22237",
    "data-name": "Path 22237",
    d: "M-9.02-2.038c1.11,0,26.631-1.983,26.985-1.069C20.706-1.94,26.71,11.622,26.71,13.419c0,2.231-2.65,2.331-4.731,2.359-2.792.429-15.864,0-16.711,0s-4.2,1.678-5.5,0c-1.033-1.328-4.911-4.75-4.911-7.022C-5.145,4.184-10.848-2.038-9.02-2.038Z",
    transform: "matrix(-0.017, 1, -1, -0.017, 421.145, 2905.132)",
    fill: "#dd2228",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22463",
    "data-name": "Group 22463",
    transform: "translate(296 2839.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22462",
    "data-name": "Group 22462",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22234",
    "data-name": "Path 22234",
    d: "M157.131,37.316,80.343.246a2.478,2.478,0,0,0-2.154,0L1.4,37.316A2.477,2.477,0,0,0,0,39.547v90.028a2.477,2.477,0,0,0,1.4,2.231l76.788,37.07a2.478,2.478,0,0,0,2.154,0l76.788-37.07a2.477,2.477,0,0,0,1.4-2.231V39.547a2.478,2.478,0,0,0-1.4-2.231M79.266,5.228l71.09,34.319L129.748,49.5a2.456,2.456,0,0,0-.419-.264L58.722,15.146ZM53.127,17.947l70.987,34.269-14.539,7.019L38.617,24.98Zm72.647,38.969V82.861l-13.58,6.556V63.472Zm27.8,71.1L81.743,162.7V78.172L98.878,69.9a2.477,2.477,0,1,0-2.154-4.462L79.266,73.866,72.4,70.55a2.477,2.477,0,0,0-2.154,4.462l6.546,3.16V162.7L4.955,128.02V43.494L59.655,69.9a2.477,2.477,0,0,0,2.154-4.462L8.176,39.547l24.61-11.881L107.2,63.592c.011.015.023.029.034.044V93.364a2.477,2.477,0,0,0,3.555,2.231l18.535-8.948a2.477,2.477,0,0,0,1.4-2.231V54.524l22.848-11.03Z",
    transform: "translate(0 0)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22235",
    "data-name": "Path 22235",
    d: "M46.84,346.949l-11.269-5.44a2.477,2.477,0,0,0-2.154,4.462l11.269,5.44a2.477,2.477,0,0,0,2.154-4.462",
    transform: "translate(-21.441 -228.537)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22236",
    "data-name": "Path 22236",
    d: "M57.243,316.377,35.619,305.937a2.477,2.477,0,0,0-2.154,4.462l21.624,10.439a2.477,2.477,0,0,0,2.154-4.462",
    transform: "translate(-21.473 -204.715)",
    fill: "#212121"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorksImg4);
export default __webpack_public_path__ + "static/media/how-it-works-img-4.520964f39df44b0d465f5a472454d174.svg";
export { ForwardRef as ReactComponent };